import * as React from 'react';

import * as style from './style.css';

export const PushToCallTooltipContent = () => {
  return (
    <span className={style['content']}>Позвоните&nbsp;напрямую застройщику,&nbsp;без&nbsp;участия посредников</span>
  );
};
